import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice du débit de filtration glomérulaire (GFR)";
const DESCRIPTION =
  "Calculatrice du débit de filtration glomérulaire (GFR) en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "du débit de filtration glomérulaire gfr, calculatrice du débit de filtration glomérulaire gfr, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gfr-calculator/";

function GFRCalculator() {
  const [creatinine, setCreatinine] = useState(0.2);
  const [age, setAge] = useState(12);
  const [gender, setGender] = useState("male");
  const [result, setResult] = useState();
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const k = gender === "female" ? 0.7 : 0.9;
      const alpha = gender === "female" ? -0.241 : -0.302;
      const minScr = Math.min(creatinine / k, 1);
      const maxScr = Math.max(creatinine / k, 1);
      const gfr =
        142 *
        Math.pow(minScr, alpha) *
        Math.pow(maxScr, -1.2) *
        Math.pow(0.9938, age) *
        (gender === "female" ? 1.012 : 1);
      setResult(gfr.toFixed(2));
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Calculez votre débit de filtration glomérulaire (GFR) maintenant et prenez des mesures proactives pour protéger votre santé! Notre calculatrice innovante utilise les dernières équations médicales (CKD-EPI) pour évaluer avec précision la fonction rénale. En connaissant votre valeur GFR, vous pouvez:
                </p>
                <ul>
                  <li>
                    Détecter les maladies rénales tôt: Détectez tout problème rénal à ses débuts et recevez le traitement approprié.
                  </li>
                  <li>
                    Surveiller l'efficacité du traitement: Suivez l'effet des médicaments et des traitements sur la santé rénale.
                  </li>
                  <li>
                    Prendre des décisions éclairées: Consultez votre médecin en fonction des résultats du calcul pour déterminer le meilleur plan de traitement.
                  </li>
                </ul>
                <p>
                  Simplement, entrez les valeurs de créatinine, l'âge et le sexe, et cliquez sur "Calculer".
                </p>
                <p>
                  La calculatrice a été construite se basant sur{" "}
                  <a href="https://www.kidney.org/ckd-epi-creatinine-equation-2021" rel="nofollow">la Fondation rénale internationale</a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="creatinine">
                      <label className="form-label ms-2">
                        Entrez le niveau de créatinine
                      </label>
                      <input
                        id="creatinine"
                        type="number"
                        value={creatinine}
                        onChange={(e) => setCreatinine(e.target.value)}
                        placeholder="Entrez le niveau de créatinine"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        Sélectionnez l'âge
                      </label>
                      <select
                        id="age"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        {[...Array(88)].map((_, i) => (
                          <option key={i + 12} value={i + 12}>
                            {i + 12}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="gender">
                        Sélectionnez le sexe
                      </label>
                      <select
                        id="gender"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="male">Homme</option>
                        <option value="female">Femme</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p className="text-white">{`Débit de filtration glomérulaire (GFR): ${result} mL/min/1,73m²`}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Qu'est-ce que le DFG ?</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Interprtation des rsultats</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GFRCalculator;
